const sharedStyles = {
  wrapperStyles:
    'fixed min-h-[3rem] sm:left-auto sm:top-auto text-white fill-white flex flex-col p-4 md:p-6 w-full sm:w-auto sm:max-w-[80%] md:max-w-[800px] font-GoodPro text-14 tracking-0.6 md:min-w-[600px]'
}

export const AlertPositions = {
  mobilePosition: 'left-0 top-0',
  top: 'items-start justify-center',
  bottom: 'items-end justify-center',
  center: 'items-center justify-center',
  left: 'justify-start',
  right: 'justify-end'
}

export const AlertStyles = {
  error: `bg-accentRed ${sharedStyles.wrapperStyles}`,
  success: `bg-accentGreen ${sharedStyles.wrapperStyles}`,
  warning: `bg-accentYellow ${sharedStyles.wrapperStyles}`,
  standard: `bg-white text-black fill-black ${sharedStyles.wrapperStyles}`
}
